import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import {apiUrl} from '@/utils/api';

type MutationProps = {
    associateID : number;
    labelText : string;
};

export const useAddCapacityDefault = () : UseMutationResult<
    void,
    unknown,
    MutationProps
> => {
    const fetch = useApiFetch();
    const queryClient = useQueryClient();

    return useMutation(async (values : MutationProps) : Promise<void> => {
        const {associateID, labelText} = values;

        try {
            await fetch(apiUrl('/v1/capacity/capacity/add-capacity-default').toString(), {
                method: 'PUT',
                body: JSON.stringify({
                    associateID,
                    labelText,
                }),
            });
        } catch (e : unknown) {
            throw new Error('Unable to add capacity default.');
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['capacityLabels']);
            await queryClient.invalidateQueries(['capacityDefaults']);
            await queryClient.invalidateQueries(['capacityCombined']);
        },
    });
};
